export const invitationToModel = (obj: IRegisterInvitationJson): IRegisterInvitation => {
	const { email, role, token } = obj

	return {
		email,
		role,
		token,
	}
}
